import { render, staticRenderFns } from "./DocView.vue?vue&type=template&id=4355f34a&"
import script from "./DocView.vue?vue&type=script&lang=js&"
export * from "./DocView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports